<div class="text-start text-dark w-100 shadow-sm p-3 bg-white d-block rounded overflow-hidden">
    <div class="d-flex align-items-center">
        <i class="fa-regular fa-calendar-days me-1"></i>
        <span class="fs-4 mb-0 fw-regular text-start text-nowrap">
            {{ item.from | date: "EE dd.MM.yy | HH:mm" }}
        </span>
        <span class="fs-4"> - </span>
        <span class="fs-4 mb-0 fw-regular text-start text-nowrap">
            <ng-container *ngIf="isAssignmentOnSameDay(item.from, item.to) else fullDate">
                {{ item.to | date: "HH:mm" }}
            </ng-container>
            <ng-template #fullDate>
                {{ item.to | date: "EE dd.MM.yy | HH:mm" }}
            </ng-template>
        </span>
    </div>
    <div class="fs-4 mb-0 fw-bold text-truncate">
        <span class="h8">{{item.sportName}} | {{item.title}}</span>
    </div>
    <p class="fs-4 fw-regular" *ngIf="item.location != null">
      {{ item.location }}
    </p>
    <p class="fs-4 fw-regular">
        <b>{{'assignments.billedAssignments.salary' | transloco}}: </b>
        <span style="white-space: nowrap;">
            {{'shared.swissFranc' |transloco}} {{ item.salary| number: '1.2-2'}}
        </span>
    </p>
    <p class="fs-4 fw-regular" *ngIf="item.reasonForAbsence">
        <b>{{'assignments.billedAssignments.reasonForAbsence' | transloco}}: </b>
        <span>
            {{ item.reasonForAbsence}}
        </span>
    </p>

    <p class="fs-4 fw-regular" *ngIf="item.salaryDetails">
        <b>{{'assignments.billedAssignments.salaryDetails' | transloco}}: </b>
        <span>
            {{ item.salaryDetails}}
        </span>
    </p>
</div>
